import type { EditorJsContent, EditorJsBlock } from "@/Types/responses/common";

function getBlockText(block: EditorJsBlock): string {
  switch (block.type) {
    case "paragraph":
    case "header": {
      const text = block.data?.text;
      return typeof text === "string" ? text : "";
    }
    case "list": {
      const items = block.data?.items;
      return Array.isArray(items)
        ? items.filter((item): item is string => typeof item === "string").join(" ")
        : "";
    }
    default:
      return "";
  }
}

export function getExcerptText(content: EditorJsContent, maxLength = 160): string {
  if (!content?.blocks?.length) return "";

  const text = content.blocks
    .map(getBlockText)
    .join(" ")
    .replace(/<[^>]*>/g, "")
    .trim();

  return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
}